<template>
    <div class="container-xxl mb-1 py-0 pb-lg-4">
        <slot/>
    </div>
</template>

